export class ZoneConnection {
	public date: string
	public dayOfWeek: number
	public connections: { [key: string]: boolean }

	constructor(data: {
		date: string
		dayOfWeek: number
		connections: { [key: string]: boolean }
	}) {
		this.date = data.date
		this.dayOfWeek = data.dayOfWeek
		this.connections = data.connections
	}

	static create(data: Partial<ZoneConnection>): ZoneConnection {
		const defaultData: ZoneConnection = {
			date: '',
			dayOfWeek: 0,
			connections: {},
		}

		return new ZoneConnection({
			...defaultData,
			...data,
		})
	}
}
